import { DOMNodeProps } from "@/types";
import styles from "./FakeLink.module.scss";

export default function FakeLink({ children, className, ...props }: DOMNodeProps) {
  return (
    <span
      className={[styles.FakeLink, className].join(" ")}
      {...props}
    >
      {children}
    </span>
  );
}
